import { configurationKeys } from '../constants/clientConstants';

export const getCaptchaProvider = (openIDConnectService) =>
  (
    openIDConnectService.getEsignetConfiguration(
      configurationKeys.captchaProvider
    ) ||
    process.env.REACT_APP_CAPTCHA_PROVIDER ||
    'legacy'
  )
    .trim()
    .toLowerCase();

export const getCaptchaSiteKey = (openIDConnectService) =>
  openIDConnectService.getEsignetConfiguration(
    configurationKeys.captchaSiteKey
  ) ?? process.env.REACT_APP_CAPTCHA_SITE_KEY;
